import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { PENDING_BALANCES_QUERY_KEY } from "./constants";
import { buildPendingBalancesQuery, type PendingBalancesFilters } from "./pending-balances-filters";
import type { PendingBalancesResponse } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/payouts/
 * pending-balances` is the live "who do we owe" report (API-FIN-1), ordered
 * oldest-accrual-first. Read tier: WANDERFIT_ADMIN + WANDERFIT_FINANCE.
 */
async function fetchPendingBalances(
  filters: PendingBalancesFilters,
): Promise<PendingBalancesResponse> {
  return httpClient<PendingBalancesResponse>(
    `/api/admin/payouts/pending-balances${buildPendingBalancesQuery(filters)}`,
  );
}

export function usePendingBalances(filters: PendingBalancesFilters) {
  return useQuery({
    queryKey: [
      ...PENDING_BALANCES_QUERY_KEY,
      filters.connect,
      filters.olderThanMonths ?? "any",
    ] as const,
    queryFn: () => fetchPendingBalances(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
